import { render, staticRenderFns } from "./company-manage.vue?vue&type=template&id=1114ede3"
import script from "./company-manage.vue?vue&type=script&lang=ts"
export * from "./company-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports